export const PARSE_STATUS = [
  {
    id: 0,
    label: "Ok",
    color: "success",
  },
  {
    id: 1,
    label: "Error",
    color: "error",
  },
  {
    id: 2,
    label: "Varning",
    color: "warning",
  },
];
